import ReadMoreLess from './ReadMoreLess'

export default ReadMoreLess
// eslint-disable-next-line import/export
export * from './ReadMoreLess'
